/* eslint-disable */
export const ONE_MILLION = 1000000;
export const OVERNIGHT_FOLDER_NAME = 'upload-process-overnight';
export const SCHEDULED_STATUS = 'Scheduled';

export const PROCESS_FOLDER_NAME = 'upload-process';
export const PENDING_STATUS = 'Pending';

export const PRICING_RULES_FOLDER_NAME = 'upload-pricing-rules';
export const WAITING_FOR_APPROVAL_STATUS = 'Waiting for Approval';
